//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SuccessDialogPushpaymentIM",
  props: ["status", "title", "message", "text_color", "link", "querydata"],
  beforeDestroy() {
    // console.log("SuccessDialog beforeDestroy");
    // this.$store.commit("set_global_dialog", false);
    // this.$store.state.global_dialog = false;
  },
  methods: {
    closeDialogSendmail(tlink,querydata) {
      this.$store.commit("set_global_dialog", false);
      this.$store.state.global_push_dialog = false;
      if (tlink === "/reloadpage") {
        this.$router.go();
      } else {
        this.$router.push({ path:`${tlink}`, query:querydata} );
      }
      // this.$router.push(`${tlink}`);
      //"/advance-list"
    },
  },
};
